import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyListStart } from "../../../Store/Slices/organizationSlice";
import { Button, Dropdown, Modal } from "react-bootstrap";

const OrganizationContent = ({
    showQTOrganizationContent,
    setshowQTOrganizationContent,
    QTOrganizationValues,
    handleInsertQTOrganizationPlaceholder,
    handleQTOrganizationValuesChange
}) => {
    const dispatch = useDispatch();
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let [organizationPlaceholders, setOrganizationPlaceholders] = useState([])

    const formatText = (text) => {
        return text
            .replace(/_/g, ' ')                  // Replace underscores with spaces
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
            .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    }

    useEffect(() => {
        dispatch(getCompanyListStart());
    }, [])

    useEffect(() => {
        if (currentOrg) {
            let fields = Object.keys(currentOrg)
                .filter(item =>
                    item !== '__v' && item !== '_id' && item !== 'createdBy' && item !== 'isActive' &&
                    item !== 'access_url' && item !== 'createdAt' && item !== 'updatedAt'
                ).map(data => ({ key: data, value: formatText(data) }))
            if (fields) {
                let newItem = {
                    categoryTitle: 'ORGANIZATION',
                    items: fields
                }
                setOrganizationPlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === 'ORGANIZATION');
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [currentOrg])

    return (
        <Modal show={showQTOrganizationContent} onHide={setshowQTOrganizationContent} size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">Organization Address Format (Displayed in PDF only)</span>
                    {/* <TooltipTrig id="orgAddressFormatInfo" placement={"right"}
                        title={<span className="pe-4 d-inline-block">Placeholders and characters like comma, space, -, ., : are allowed.</span>}>
                        <span className="ps-1 text-gray">
                            <GoQuestion size={20} />
                        </span>
                    </TooltipTrig> */}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* {orgAddConfigShow ? (
                    <>
                        <textarea rows={9} id="org_custom_cont_input" className="form-control border-0 text-uppercase"
                            value={orgAddCustomValues} disabled></textarea>
                        <div className="mt-2 form-text text-muted">
                            This is the common address format. To edit this address format, go to
                            <span className="fw-semibold ps-1">Settings &gt; Preferences &gt; General</span>.
                        </div>
                        <div className="mt-4 mb-0 alert alert-light d-flex align-items-center" role="alert">
                            <div className="text-info">
                                <i className="fa-solid fa-circle-info fs-5"></i>
                            </div>
                            <div className="ms-2 small">
                                Do you want to have a custom address format only for this template ?
                            </div>
                            <div className="ms-auto">
                                <button type="button" className="btn btn-link text-decoration-none small px-0"
                                    onClick={() => setOrgAddConfigShow()}>
                                    <Settings size={16} /> <span className="ps-1">Configure</span>
                                </button>
                            </div>
                        </div>
                    </>
                ) : ( */}
                <>
                    <div className="card p-0">
                        <div className="card-header d-flex justify-content-between">
                            <Dropdown>
                                <Dropdown.Toggle variant="light" className="with-arrow px-3" id="orgCont_dropdownBtn">
                                    <span className="pe-3">Insert Placeholder</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="max-h-400px">
                                    <div className="hstack align-items-start">
                                        {organizationPlaceholders?.length > 0 && organizationPlaceholders.map((categoryTitle, index) => (
                                            <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                                <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                                {categoryTitle.items.map((item, itemIndex) => (
                                                    <Dropdown.Item key={itemIndex} onClick={() => handleInsertQTOrganizationPlaceholder(categoryTitle.categoryTitle, item.value)}>
                                                        {item.value}
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <textarea rows={9} id="org_cont_input" className="form-control border-0 text-uppercase"
                            value={QTOrganizationValues} onChange={handleQTOrganizationValuesChange}></textarea>
                    </div>
                    <div className="mt-3 alert alert-warning d-flex" role="alert">
                        <div className="text-warning">
                            <i className="fa-solid fa-circle-info fs-6"></i>
                        </div>
                        <div className="ms-2 small pe-3">
                            This custom address format will be used only in this template.
                            If you leave the custom address format empty,
                            the common address format will be used.
                        </div>
                    </div>
                </>
                {/* )} */}
            </Modal.Body>
            {/* <Modal.Footer>
                {orgAddConfigShow ? (
                    <Button variant="outline-secondary" className="py-1 me-auto" onClick={orgAddressModalClose}>
                        Close
                    </Button>
                ) : (
                    <>
                        <Button variant="primary" className="py-1" onClick={orgAddressModalClose}>
                            Preview
                        </Button>
                        <Button variant="outline-secondary" className="py-1" onClick={orgAddressModalClose}>
                            Cancel
                        </Button>
                        <Button variant="link" type="reset" className="p-0 py-2 ms-auto text-decoration-none"
                            onClick={() => setOrgAddConfigShow(true)}>Use Common Format</Button>
                    </>
                )}
            </Modal.Footer> */}
        </Modal>
    )
}
export default OrganizationContent;